class ScrollShiftHandler {
  constructor() {
    this.scrollShifts = document.querySelectorAll(".scroll-shift");
    this.prefersReducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    if (!this.scrollShifts.length || this.prefersReducedMotion) return;
    this._init();
  }

  _init() {
    window.addEventListener("scroll", () => this._onScroll());
  }

  _onScroll() {
    this.scrollShifts.forEach((shift) => {
      const top = shift.getBoundingClientRect().top;
      const offset = 0.4;
      const direction = shift.classList.contains("scroll-reverse_direction")
        ? -offset
        : offset;
      shift.style.transform = `translate(calc(-75% + ${top * direction}px), 0)`;
    });
  }
}

class StickyFooterHandler {
  constructor() {
    this.footer = document.querySelector(".sticky-footer");
    this.mm = window.matchMedia("(min-width: 1000px)");
    if (!this.footer || !this.mm.matches) return;
    this._hideOnScrollUp();
  }

  _hideOnScrollUp() {
    const scrollVal = 100;
    const hiddenClass = "sticky-footer--hidden";

    const hasScrolled = window.scrollY > scrollVal;
    if (!hasScrolled) this.footer.classList.add(hiddenClass);

    window.addEventListener(
      "scroll",
      () => {
        const hasScrolled = window.scrollY > scrollVal;
        this.footer.classList.toggle(hiddenClass, !hasScrolled);
      },
      { passive: true },
    );
  }
}

class FooterCreditHandler {
  constructor() {
    this.footerLeft = document.querySelector(".footer__left p");
    if (!this.footerLeft) return;
    this._init();
  }

  _init() {
    const credit = document.createElement("span");
    credit.classList.add("footer__credit");
    credit.innerHTML =
      '<a href="https://www.danielleallyssa.com/" target="_blank" rel="noopener">Site Credit</a>';
    this.footerLeft.appendChild(credit);
  }
}

const sizeGuideListHandler = {
  modal: document.getElementById("sizeGuideModal"),
  modalBtn: document.getElementById("size-guide-modal-btn"),
  closeBtn: document.getElementById("guide-list__close"),
  init() {
    if (!this.modalBtn || !this.modal) return;

    const closeElements = [this.modal, this.closeBtn];

    this.modalBtn.onclick = (e) => {
      console.log("Modal: ", this.modal);
      console.log("Modal button: ", this.modalBtn);
      console.log("Close button: ", this.closeBtn);
      this.modal.style.display = "flex";
      document.body.style.overflow = "hidden";
    };

    closeElements.forEach((element) => {
      element.onclick = (e) => {
        this.modal.style.display = "none";
        document.body.style.overflow = "";
      };
    });
  },
};

document.addEventListener("DOMContentLoaded", () => {
  new StickyFooterHandler();
  new FooterCreditHandler();
  new ScrollShiftHandler();
  sizeGuideListHandler.init();
});

document.addEventListener("shopify:section:load", () => {
  new ScrollShiftHandler();
});

document.addEventListener("shopify:section:reorder", () => {
  new ScrollShiftHandler();
});
